export function getView(appointment_overlay) {
  return (
    appointment_overlay.patient_option === 'new' ||
    Boolean(appointment_overlay.patient_id)
  )
}
